import { CLIENT_TYPES } from "../../../constants/personaldata";

export const formControls = {
    documentType: {
        key: "documentType",
        placeholder: "Seleccione",
        label: "Tipo y Nº de documento",
    },
    documentNumber: {
        key: "documentNumber",
        placeholder: "N° de documento",
    },
    cellphone: {
        key: "cellphone",
        placeholder: "Nº de celular",
        label: "N° Celular",
    },
    email: {
        key: "email",
        placeholder: "Ingresar Email",
        label: "Email",
    },
    names: {
        key: "names",
        placeholder: "Ingresa nombres completos",
        label: "Nombres",
    },
    firstSurname: {
        key: "firstSurname",
        placeholder: "Apellido",
        label: "Apellido paterno",
    },
    lastSurname: {
        key: "lastSurname",
        placeholder: "Apellido",
        label: "Apellido materno",
    },
    birthDate: {
        key: "birthDate",
        placeholder: "DD/MM/AAAA",
        label: "Fecha de Nacimiento",
    },
    clientType: {
        key: "clientType",
        label: "¿Qué tipo de cliente eres?",
        owner: {
            key: CLIENT_TYPES.OWNER,
            text: "Propietario",
        },
        roomer: {
            key: CLIENT_TYPES.ROOMER,
            text: "Inquilino",
        },
    },
    whichEnsure: {
        key: "whichEnsure",
        label: "¿Qué quieres asegurar?",
    },
    housingType: {
        key: "housingType",
        label: "Elige el tipo de inmueble",
    },
    personalDataConsent: {
        key: "personalDataConsent",
    },
    contactConsent: {
        key: "contactConsent",
    },
};
